
import React,{useRef} from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,MenuItem,
  Typography,
  IconButton,
  CircularProgress,
   Select, 
   TablePagination,
   Pagination
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useState } from "react";
import { showUnderDevelopment } from "../../../components/Alert.js";
import StatusDropdown from "../../../components/StatusDropdown";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../components/CustomText";
 import AttendanceDetailsDrawer from "../Attendance/TodaysLogs/DetailsDrawer.js"; // adjust the path
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import mapicon from "../../../assets/Dashboard/mapicon.svg";
import CustomButton from "../../../components/CustomButton";
import maparrow from "../../../assets/maparrow.svg";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from "../../../components/BaseUrl";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";// ✅ Import DatePicker
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import empty from "../../../assets/empty.png";
import TruncatedCell from "../../../components/TruncatedCell.js";
import { useNavigate } from "react-router-dom";
import { convertUTCToLocalDateTime } from "../../../components/dateTimeUtils";
import { useTheme } from "../../../contexts/ThemeContext";
import {
  getGoogleMapsPinIconForStatus,
  getStatusBadgeBackgroundColor,
} from "../../../constants/statusPalette";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
const defaultCenter = { lat: 37.0902, lng: -95.7129 };
const mapContainerStyle = { width: "100%", height: "100%" };

const HaederStyles = {
  color: "#44546F",
  fontSize: "13px",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
  textAlign: "left",
   whiteSpace: 'nowrap', 
      overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const DataStyles = {
  color: "#172B4D",
  fontSize: "13px",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 400,
  textAlign: "left",
   whiteSpace: 'nowrap', 
      overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const DashboardTable = ({ onRowClick }) => {
  const { t } = useTranslation();
  const { primaryColor } = useTheme();
const [showFullMap, setShowFullMap] = useState(false);
const [openDatePicker, setOpenDatePicker] = useState(false);
const [activePin, setActivePin] = useState(null);

  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const navigate = useNavigate();
  // State
  const [tableRows, setTableRows] = useState([]);
  const [mapData, setMapData] = useState(null);
  const [loading, setLoading] = useState(true);
const dateRef = useRef(null);
const mapRef = useRef(null);
const fullMapRef = useRef(null);

  // Drawer/menu states
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs());

  const [date, setDate] = useState(dayjs());
  const [filterOpen, setFilterOpen] = useState(false);
const [selectedFilter, setSelectedFilter] = useState("");
const [isFilterApplied, setIsFilterApplied] = useState(false);
useEffect(() => {
  const fetchData = async () => {
    if (!decryptedToken) {
      console.warn("⚠️ No token found, skipping fetch");
      return;
    }

    try {
      setLoading(true);

      const formattedDate = dayjs(date).format("YYYY-MM-DD");
let url = `${BASE_URL}/company-admins/attendance/today-last-punch?date=${formattedDate}`;
console.log("➡️ Base URL:", url);

if (selectedFilter) {
  url += `&filter=${selectedFilter}`;
  console.log("🎯 Filter applied:", selectedFilter);
}

console.log("🔗 Final API URL:", url);
      console.log("📡 Fetching attendance logs for date:", formattedDate);
      console.log("🔗 Full API URL:", url);

      const res = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      console.log("📥 Raw response status:", res.status);

      const json = await res.json();
      console.log("✅ API JSON response:", json);
      console.log("📌 today-last-punch response:", json);

      if (!json.error) {
        setTableRows(json.data.table?.rows || json.data.rows || []);
        // setMapData(json.data.map || null);
        const normalizedMap = {
...json.data.map,
pins: (json.data.map?.pins || []).map((p) => ({
...p,
lastStatus:
p.lastStatus ||
p.last_status ||
p.workerStatus ||
p.worker_status ||
null,
workerStatus:
p.workerStatus ||
p.worker_status ||
p.lastStatus ||
p.last_status ||
null,
lastPunchTime:
p.lastPunchTime ||
p.last_punch_time ||
p.punch_time ||
p.punched_at ||
p.last_activity_time ||
null,
})),
};


setMapData(normalizedMap);

        // Debugging table rows
        console.log("📊 Parsed table rows:", json.data.table?.rows || json.data.rows || []);
        console.log("🗺️ Parsed map data:", json.data.map);
      } else {
        console.warn("⚠️ API returned error:", json.message);
      }
    } catch (err) {
      console.error("❌ Error fetching attendance:", err);
      alert("❌ Error fetching attendance: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [decryptedToken, date, selectedFilter]);

const [drawerOpen, setDrawerOpen] = useState(false);


const handleOpenDetails = (row) => {
  setSelectedRow(row);
  setDrawerOpen(true);
};
const [anchorEl, setAnchorEl] = useState(null);
const [menuRow, setMenuRow] = useState(null); // store the clicked row

const handleMenuOpen = (event, row) => {
  setAnchorEl(event.currentTarget);
  setMenuRow(row);
};

const handleMenuClose = () => {
  setAnchorEl(null);
  setMenuRow(null);
};



const formatLocalTime = (utcString) => {
  const localValue = convertUTCToLocalDateTime(utcString, {
    locale: "en-GB",
    formatOptions: { hour: "numeric", minute: "2-digit", hour12: true },
  });
  return localValue === "—" ? "-" : localValue;
};

const toDisplayTime = (value) => {
  if (value === null || value === undefined || value === "") return "-";

  const converted = formatLocalTime(value);
  if (converted !== "-") return converted;

  if (typeof value === "string" && value.trim()) return value.trim();
  return "-";
};

const getPunchTimeByAction = (row, actionType) => {
  const punches = Array.isArray(row?.punches) ? row.punches : [];
  const matchedPunch = punches.find((punch) => punch?.actionType === actionType);
  if (matchedPunch) {
    return toDisplayTime(
      matchedPunch?.occurredAt || matchedPunch?.formattedDateTime || null
    );
  }

  // today-last-punch rows use flat fields (not punches[]) — same values as before
  const flatByAction = {
    CLOCK_IN: [
      row?.previousClockInTime,
      row?.allTimes?.previousClockInTime,
      row?.allTimes?.previousClockInFormatted,
    ],
    BREAK_START: [
      row?.breakStartTime,
      row?.allTimes?.breakStartTime,
      row?.allTimes?.breakStartFormatted,
    ],
    BREAK_END: [
      row?.breakEndTime,
      row?.allTimes?.breakEndTime,
      row?.allTimes?.breakEndFormatted,
    ],
    CLOCK_OUT: [
      row?.clockOutTime,
      row?.allTimes?.clockOutTime,
      row?.allTimes?.clockOutFormatted,
    ],
  };

  const candidates = flatByAction[actionType] || [];
  for (const value of candidates) {
    const displayed = toDisplayTime(value);
    if (displayed !== "-") return displayed;
  }
  return "-";
};
const [page, setPage] = useState(1);
const rowsPerPage = 5;

const paginatedRows = tableRows.slice(
  (page - 1) * rowsPerPage,
  page * rowsPerPage
);

const totalPages = Math.ceil(tableRows.length / rowsPerPage);

/** Legend dots — same fills as StatusDropdown (`statusPalette`). */
const getLegendDotColor = (status) => getStatusBadgeBackgroundColor(status);

/** Map pins — fill + ring from palette for this status key. */
const getMarkerIcon = (status) => getGoogleMapsPinIconForStatus(status);
const tableStatusByPunchId = React.useMemo(() => {
  const statusMap = new Map();
  tableRows.forEach((row) => {
    if (row?.punchId != null && row?.lastStatus) {
      statusMap.set(String(row.punchId), row.lastStatus);
    }
  });
  return statusMap;
}, [tableRows]);

const tableLastPunchTimeByPunchId = React.useMemo(() => {
  const timeMap = new Map();
  tableRows.forEach((row) => {
    if (row?.punchId != null && row?.lastPunchTime) {
      timeMap.set(String(row.punchId), row.lastPunchTime);
    }
  });
  return timeMap;
}, [tableRows]);

const getPinStatus = (pin) =>
  (pin?.punchId != null && tableStatusByPunchId.get(String(pin.punchId))) ||
  pin?.lastStatus ||
  pin?.workerStatus ||
  pin?.last_status ||
  pin?.worker_status ||
  "-";

const formatStatusLabel = (status) => {
  if (!status || status === "-") return "-";
  return String(status)
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
const getPinDisplayTime = (pin) =>
  toDisplayTime(
    (pin?.punchId != null && tableLastPunchTimeByPunchId.get(String(pin.punchId))) ||
      pin?.lastPunchTime ||
      pin?.last_punch_time ||
      pin?.formattedTime ||
      pin?.punch_time ||
      pin?.time ||
      null
  );
const handleIcon = () => {
    navigate("/todays-logs", { state: { fromDashboard: true } });
}
const [selectedWorkerId, setSelectedWorkerId] = useState(null);
const filteredPins = React.useMemo(() => {
  if (!mapData?.pins) return [];
  if (!selectedWorkerId) return mapData.pins;

  return mapData.pins.filter(
    (p) => p.punchId === selectedWorkerId
  );
}, [mapData, selectedWorkerId]);

const getMapCenter = () =>
  filteredPins.length > 0
    ? {
        lat: filteredPins[0].coordinates.lat,
        lng: filteredPins[0].coordinates.lng,
      }
    : defaultCenter;

const fitMapToPins = (map) => {
  if (!map || !window.google?.maps) return;

  if (!filteredPins.length) {
    map.setCenter(defaultCenter);
    map.setZoom(5);
    return;
  }

  if (filteredPins.length === 1) {
    map.setCenter({
      lat: filteredPins[0].coordinates.lat,
      lng: filteredPins[0].coordinates.lng,
    });
    map.setZoom(13);
    return;
  }

  const bounds = new window.google.maps.LatLngBounds();
  filteredPins.forEach((pin) => {
    bounds.extend({
      lat: pin.coordinates.lat,
      lng: pin.coordinates.lng,
    });
  });
  map.fitBounds(bounds, 50);
};

useEffect(() => {
  if (activePin) {
    const stillVisible = filteredPins.some(
      (pin) => (pin.punchId || pin.workerId) === (activePin.punchId || activePin.workerId)
    );
    if (!stillVisible) setActivePin(null);
  }
}, [filteredPins, activePin]);

useEffect(() => {
  fitMapToPins(mapRef.current);
  if (showFullMap) {
    fitMapToPins(fullMapRef.current);
  }
}, [filteredPins, showFullMap]);
/** Keys must match `statusStyles` in statusPalette so legend dots = map pins = badges. */
const mapStatusLegend = [
  { key: "CLOCK_IN", label: t("clock_in") },

  { key: "EARLY_CLOCK_IN", label: t("early_clock_in") },
  { key: "LATE_CLOCK_IN", label: t("late_clock_in") },
  { key: "BREAK_START", label: t("break_start") },
  { key: "BREAK_END", label: t("break_end") },
  { key: "CLOCK_OUT", label: t("clock_out") },
  { key: "EARLY_CLOCK_OUT", label: t("early_clock_out") },
  { key: "LATE_CLOCK_OUT", label: t("late_clock_out") },
  { key: "ON_LEAVE", label: t("on_leave") },
  { key: "ON_HALF_LEAVE", label: t("on_half_leave") },
  { key: "ABSENT", label: t("absent") },
];

  return (



    <>
    
    
          <Box sx={{ borderRadius: 2, mt: 2, border: "1px solid #091E4224", borderRadius: "6px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#fff",
          padding: "12px 16px",
          borderRadius: "8px",
          mb: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            minHeight: 34,
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 700,
              color: "#212121",
              fontFamily: "Poppins Sans, sans-serif",
              lineHeight: 1.2,
            }}
          >
            {t("today_punches")}
          </Typography>
          {selectedWorkerId && (
            <IconButton
              onClick={() => setSelectedWorkerId(null)}
              size="small"
              aria-label={t("close")}
              sx={{
                width: 30,
                height: 30,
                p: 0,
                backgroundColor: "error.main",
                "&:hover": { backgroundColor: "error.dark" },
              }}
            >
              <CloseRoundedIcon sx={{ color: "common.white", fontSize: 18 }} />
            </IconButton>
          )}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    
             <LocalizationProvider dateAdapter={AdapterDayjs}>

<DatePicker
    // open={openDatePicker}
    // onClose={() => setOpenDatePicker(false)} 

  value={date}
  onChange={(newDate) => setDate(newDate)}
//  open={openDatePicker}  format="YYYY-MM-DD"
      maxDate={dayjs()}   
  enableAccessibleFieldDOMStructure={false}
  slotProps={{

    textField: {
      size: "small",
                  // onClick: () => setOpenDatePicker(true),   // ✅ makes whole field clickable

        //             onClick: () => setOpenDatePicker(true),   // ✅ FULL FIELD CLICKABLE
        // onFocus: () => setOpenDatePicker(true), 
      sx: {
        "& .MuiInputBase-root": {
          height: 34,
          fontSize: "14px",
        },
        "& .MuiInputBase-input": {
          padding: "2px 6px",
          fontSize: "14px",
        },
        "& .MuiSvgIcon-root": {
          fontSize: "16px",
        },
      },
    },
    popper: {
      sx: {
        "& .MuiPickersCalendarHeader-label": {
          fontSize: "14px", // shrink Month-Year label
          fontWeight: 500,
        },
        "& .MuiPickersCalendarHeader-switchViewButton": {
          fontSize: "12px", // shrink dropdown button
        },
        "& .MuiPickersArrowSwitcher-button": {
          fontSize: "12px", // shrink arrow buttons
        },
        "& .MuiDayCalendar-weekDayLabel": {
          fontSize: "14px", // week day letters (S M T W T F S)
        },
        "& .MuiPickersDay-root": {
          fontSize: "14px", // dates inside the grid
          width: 28,        // shrink day cell width
          height: 28,       // shrink day cell height
          margin: 1,
        },
      },
    },
  }}
/>


  </LocalizationProvider>



        {/* <IconButton>
            <img
              src={mapicon}
              onClick={handleIcon}
              alt="map"
              style={{ width: 33, height: 33 }}
            />
            
          </IconButton> */}


<IconButton
  onClick={handleIcon}
  sx={{
    width: 36,
    height: 36,
    borderRadius: "6px",
    backgroundColor: primaryColor,
    color: "#fff",
    "&:hover": {
      backgroundColor: primaryColor,
      opacity: 0.9,
    },
  }}
>
  <ArrowForwardIosIcon sx={{ fontSize: 20 }} />
</IconButton>

        </Box>
      </Box>
      <Box sx={{ borderTop: "1px solid #091E4224" }}>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
      flexWrap: "wrap",
      px: 2,
      py: 1.5,
      backgroundColor: "#fff",
      borderBottom: "1px solid #091E4224",
    }}
  >
    {mapStatusLegend.map((item) => (
      <Box
        key={item.key}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.8,
        }}
      >
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: "50%",
            backgroundColor: getLegendDotColor(item.key),
          }}
        />
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: 500,
            color: "#44546F",
            fontFamily: "Poppins, sans-serif",
            whiteSpace: "nowrap",
          }}
        >
          {item.label}
        </Typography>
      </Box>
    ))}
  </Box>
  </Box>

  <Box sx={{ position: "relative", width: "100%", height: 300 }}>
{/* <Box sx={{ position: "relative", width: "100%", height: 300 }}> */}
  <GoogleMap
    mapContainerStyle={mapContainerStyle}
    center={getMapCenter()}
    zoom={13}
    onLoad={(map) => {
      mapRef.current = map;
      fitMapToPins(map);
    }}
    onUnmount={() => {
      mapRef.current = null;
    }}
    options={{
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: true,
    }}
  >
    {filteredPins.map((p) => (
      <Marker
        key={p.punchId || p.workerId}
        position={{ lat: p.coordinates.lat, lng: p.coordinates.lng }}
        icon={getMarkerIcon(getPinStatus(p))}
        onClick={() => setActivePin(p)}
      />
    ))}

    {activePin && (
      <InfoWindow
        position={{
          lat: activePin.coordinates.lat,
          lng: activePin.coordinates.lng,
        }}
        onCloseClick={() => setActivePin(null)}
      >
        <Box sx={{ minWidth: 140 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "14px" }}>
            {activePin.workerName}
          </Typography>
          <Typography sx={{ fontSize: "13px" }}>{activePin.email}</Typography>
          <Typography sx={{ fontSize: "13px" }}>
            Status: {formatStatusLabel(getPinStatus(activePin))}
          </Typography>
          <Typography sx={{ fontSize: "13px" }}>
            Time: {getPinDisplayTime(activePin)}
          </Typography>
        </Box>
      </InfoWindow>
    )}
  </GoogleMap>

  <CustomButton 
    onClick={() => setShowFullMap(true)}
   label={ <> {t("dashboard.viewFullMap")}
     <Box component="img" src={maparrow} alt="view icon"
      sx={{ ml: 1, width: 15, height: 13, objectFit: "contain" }} /> </> }
   size="small" sx={{   position: "absolute",
      top: 12,
      right: 12,
      py: 0.5,
      height: 28,
      zIndex: 1000,}} />
</Box>
    </Box>
    
   



    <Box
      sx={{
        mt: 1,
        backgroundColor: "white",
        borderRadius: 2,
        border: "1px solid #091E4224",
        boxShadow: "0px 0px 10px rgba(0,0,0,0.05)",
        overflow: "auto",
   
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
        }}
      ></Box>
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <TableContainer
          component={Paper}
          sx={{
            px: 1,
            overflowX: "auto",
            "&::-webkit-scrollbar": { height: 8 },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#C1C7D0",
              borderRadius: 8,
            },
          }}
        >
          <Table sx={{ minWidth: 1300, tableLayout: "auto" }} size="small">
            <TableHead>
              <TableRow>
                {[
                  t("common.id"),
                  t("dashboard.table.fullName"),
                  t("common.email"),
                  // t("dashboard.lastActivity"),
                  t("clockIn"),
                  t("breakStart"),
                  t("breakEnd"),
                  t("clockOut"),
                  t("dashboard.table.location"),
                  t("common.status"),
                  // t("common.action"),
                ].map((header, index) => (
                  <TableCell
                    key={header}
                    sx={{
                      ...HaederStyles,
                      py: "6px",
                      px: "12px",
                      pt: 2,
                      ...(index === 9 && {
                        textAlign: "center",
                        width: 170,
                        minWidth: 170,
                      }),
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
         <TableBody>
             
                {loading ? (
    <TableRow>
      <TableCell colSpan={10} align="center">
        <CircularProgress size={24} />
      </TableCell>
    </TableRow>
  ) : tableRows.length === 0 ? (
    <TableRow>
      <TableCell colSpan={10} align="center">
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 5,
          }}
        >
          <img
            src={empty}
            alt="No Data"
            style={{ width: 200, marginBottom: 16 }}
          />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: "16px",
              color: "#003149",
            }}
          >
            {t("empty.no_user")}
          </CustomText>
        </Box>
      </TableCell>
    </TableRow>
  ) : (
                paginatedRows.map((row, index) => (
                  <TableRow key={index} 
                    sx={{ height: "36px", cursor: "pointer" }}
onClick={() => {
  if (!row.punchId) return;
  setSelectedWorkerId(row.punchId);
}} >
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "12px" }}>{row.workerId}</TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "12px" }}>{row.fullName}</TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "12px" }}>{row.email}</TableCell>
                    {/* <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>{row.time}</TableCell> */}
                 {/* <TableCell sx={{ ...DataStyles, py: "6px", px: "12px" }}>{formatTimeTo12Hour(row.lastPunchTime)}</TableCell> */}
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "12px" }}>
                      {getPunchTimeByAction(row, "CLOCK_IN")}
                    </TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "12px" }}>
                      {getPunchTimeByAction(row, "BREAK_START")}
                    </TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "12px" }}>
                      {getPunchTimeByAction(row, "BREAK_END")}
                    </TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "12px" }}>
                      {getPunchTimeByAction(row, "CLOCK_OUT")}
                    </TableCell>
                    <TableCell sx={{ ...DataStyles, py: "6px", px: "12px" }}>
                      {/* {row.locationText} */}
                   
  {/* {row.location?.text || "-"} */}
  <TruncatedCell text={row.location?.text || "-"} maxLength={30} />
 


                    </TableCell>
                    <TableCell
                      sx={{
                        ...DataStyles,
                        py: "6px",
                        px: "12px",
                        textAlign: "center",
                        width: 170,
                        minWidth: 170,
                      }}
                    >
                      <Box sx={{ pointerEvents: "none" }}>
                        <StatusDropdown currentStatus={row.lastStatus} />
                      </Box>
                    </TableCell>
                    {/* <TableCell>
                      <IconButton size="small" 
                      onClick={(e) => handleMenuOpen(e, row)}
                      
                        >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                   
                    </TableCell> */}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
   <Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleMenuClose}
  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
  transformOrigin={{ vertical: "top", horizontal: "right" }}
>
 
     <MenuItem   
     onClick={() => {
      if (menuRow) {
        handleOpenDetails(menuRow); // use the stored row
      }
      handleMenuClose();
    }}
          sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}>
              {t("unvalidatedPunches.tableActions.view")}
          </MenuItem>
</Menu>
        </TableContainer>
<Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
  <Pagination
    count={totalPages}
    page={page}
    onChange={(e, value) => setPage(value)}
    color="primary"
    shape="rounded"
  />
</Box>
      </Box>
   <AttendanceDetailsDrawer
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  selectedRow={selectedRow}
/>
      {showFullMap && (
  <Box
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "#fff",
      zIndex: 2000,
    }}
  >
    {/* Close button */}
    <IconButton
      onClick={() => setShowFullMap(false)}
      sx={{ position: "absolute", top: 16, right: 16, zIndex: 2100,backgroundColor:"white",
        "&:hover": { backgroundColor: "white" }
       }}
    >
     <CloseIcon sx={{color:"red"}} />
    </IconButton>

    {/* Fullscreen map */}
   <GoogleMap
    mapContainerStyle={mapContainerStyle}
    center={getMapCenter()}
    zoom={13}
    onLoad={(map) => {
      fullMapRef.current = map;
      fitMapToPins(map);
    }}
    onUnmount={() => {
      fullMapRef.current = null;
    }}
    options={{
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: true,
    }}
  >
    {filteredPins.map((p) => (
      <Marker
        key={p.punchId || p.workerId}
        position={{ lat: p.coordinates.lat, lng: p.coordinates.lng }}
        icon={getMarkerIcon(getPinStatus(p))}
        onClick={() => setActivePin(p)}
      />
    ))}

    {activePin && (
      <InfoWindow
        position={{
          lat: activePin.coordinates.lat,
          lng: activePin.coordinates.lng,
        }}
        onCloseClick={() => setActivePin(null)}
      >
        <Box sx={{ minWidth: 140 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "14px" }}>
            {activePin.workerName}
          </Typography>
          <Typography sx={{ fontSize: "13px" }}>{activePin.email}</Typography>
          <Typography sx={{ fontSize: "13px" }}>
            Status: {formatStatusLabel(getPinStatus(activePin))}
          </Typography>
          <Typography sx={{ fontSize: "13px" }}>
            Time: {getPinDisplayTime(activePin)}
          </Typography>
        </Box>
      </InfoWindow>
    )}
  </GoogleMap>
  </Box>
)}
    </Box>

     </>
  );
};

export default DashboardTable;





